import { render, staticRenderFns } from "./international_waters.vue?vue&type=template&id=2259e7dc&scoped=true&"
import script from "./international_waters.vue?vue&type=script&lang=js&"
export * from "./international_waters.vue?vue&type=script&lang=js&"
import style0 from "./international_waters.vue?vue&type=style&index=0&id=2259e7dc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.10.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2259e7dc",
  null
  
)

export default component.exports